import '../layout/theme';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { ProductComparePage } from './components/productCompare/ProductComparePage';
import { ShopifyProductCompareProvider } from '../contexts/ShopifyProductCompareContext';
import { ShopifySupportProvider } from '../contexts/ShopifySupportContext';
import { IdPrefixProvider } from '@jbhi-fi/components/src/IdPrefix';
import { BaseContentProvider } from './components/stack/components/BaseContentProvider/BaseContentProvider';
import { DefaultLayout } from './components/layout/DefaultLayout';

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('compare-container');
  if (container) {
    const root = createRoot(container);
    root.render(
      <BaseContentProvider shopifyProductActionsProviderProps={{ attachPageType: 'compare' }}>
        <IdPrefixProvider prefix="compare">
          <ShopifySupportProvider>
            <ShopifyProductCompareProvider shouldHideCompare>
              <DefaultLayout shouldHideCompareBar>
                <ProductComparePage />
              </DefaultLayout>
            </ShopifyProductCompareProvider>
          </ShopifySupportProvider>
        </IdPrefixProvider>
      </BaseContentProvider>
    );
  }
});
